import { OffersListLazyWrapper } from '../OffersListLazyWrapper';
import { IComponentDefinition } from '../../../grapesJs/reactComponentsRegistry/types';
import { COMMON_COMPONENT_PROPS } from '../../../grapesJs/reactComponentsRegistry/const';

/**
 * @deprecated
 * Использовать lazyOffersListComponent
 */
export const offersListLazyWrapperComponent: IComponentDefinition = {
  ...COMMON_COMPONENT_PROPS,
  id: 'offersListLazyWrapper',
  component: OffersListLazyWrapper,
  tagName: 'offerslistlazywrapper',
  stylable: true,
  droppable: true,
  defaultAttributes: {},
  traits: [],
  block: {
    label: 'Offers List (Lazy) – Deprecated, не использовать',
    category: 'Content',
    content: '<offerslistlazywrapper><offerslist url="" /></offerslistlazywrapper>',
  },
};
